import "./Footer.css";

export default function Footer() {
  return (
    <footer className="f-footer">

      {/* Top Divider */}
      <div className="f-divider"></div>

      <div className="f-container">
        <div className="f-image-container">
          <img
            src="/assets/logos/logos2.png"
            alt="Company Logos"
            className="f-center-image"
          />
        </div>
        {/* About Us with Logo */}
        {/* <div className="f-col">
          <div className="f-col-header">
            <div className="f-logo-container">
              <svg className="f-logo" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <h2 className="f-title">About us</h2>
            </div>
          </div>
          <p className="f-text">
            Thank you for choosing to spend your time with us. We're ready when you are.
          </p>
          <a href="#" className="f-link">
            <span className="f-link-content">
              READ MORE
              <svg className="f-link-icon" viewBox="0 0 24 24" fill="none">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
          </a>
        </div> */}

        {/* Contact Info with Icons */}
        <div className="f-col">
          <div className="f-col-header">
            <div className="f-logo-container">
              <svg className="f-logo" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 16.92V19.92C22 20.47 21.55 20.92 21 20.92H19C18.45 20.92 18 20.47 18 19.92V16.92C18 16.37 17.55 15.92 17 15.92H7C6.45 15.92 6 16.37 6 16.92V19.92C6 20.47 5.55 20.92 5 20.92H3C2.45 20.92 2 20.47 2 19.92V16.92C2 13.53 4.39 10.79 7.5 10.14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M16 8.5C16 10.71 14.21 12.5 12 12.5C9.79 12.5 8 10.71 8 8.5C8 6.29 9.79 4.5 12 4.5C14.21 4.5 16 6.29 16 8.5Z" stroke="currentColor" strokeWidth="2" />
              </svg>
              <h2 className="f-title">Contact info</h2>
            </div>
          </div>

          <div className="f-contact">
            <div className="f-contact-item">
              {/* <svg className="f-contact-icon" viewBox="0 0 24 24" fill="none">
                <path d="M22 16.92V19.92C22 20.47 21.55 20.92 21 20.92H19C18.45 20.92 18 20.47 18 19.92V16.92C18 16.37 17.55 15.92 17 15.92H7C6.45 15.92 6 16.37 6 16.92V19.92C6 20.47 5.55 20.92 5 20.92H3C2.45 20.92 2 20.47 2 19.92V16.92C2 13.53 4.39 10.79 7.5 10.14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M16 8.5C16 10.71 14.21 12.5 12 12.5C9.79 12.5 8 10.71 8 8.5C8 6.29 9.79 4.5 12 4.5C14.21 4.5 16 6.29 16 8.5Z" stroke="currentColor" strokeWidth="1.5" />
              </svg> */}
              <div>
                <strong>CALL :</strong>  +1 902 270 2572
              </div>
            </div>

            <div className="f-contact-item">
              {/* <svg className="f-contact-icon" viewBox="0 0 24 24" fill="none">
                <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M22 6L12 13L2 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg> */}
              <div>
                <strong>WRITE :</strong> noshandnector@gmail.com
              </div>
            </div>

            <div className="f-contact-item">
              {/* <svg className="f-contact-icon" viewBox="0 0 24 24" fill="none">
                <path d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg> */}
              <div>
                <strong>FIND US :</strong> 100 Kings Road, Sydney, NS, B1S 1A1
              </div>
            </div>
          </div>

          {/* <a href="#" className="f-link">
            <span className="f-link-content">
              READ MORE
              <svg className="f-link-icon" viewBox="0 0 24 24" fill="none">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
          </a> */}
        </div>

        {/* Social Links */}
        <div className="f-col">
          <div className="f-col-header">
            <div className="f-logo-container">
              <svg className="f-logo" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17 2H7C4.23858 2 2 4.23858 2 7V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M16 11.37C16.1234 12.2022 15.9813 13.0522 15.5938 13.799C15.2063 14.5458 14.5931 15.1514 13.8416 15.5297C13.0901 15.9079 12.2384 16.0396 11.4078 15.9059C10.5771 15.7723 9.80976 15.3801 9.21484 14.7852C8.61991 14.1902 8.22773 13.4229 8.09406 12.5922C7.9604 11.7616 8.09206 10.9099 8.47032 10.1584C8.84858 9.40685 9.45418 8.79374 10.201 8.40624C10.9478 8.01874 11.7978 7.87659 12.63 8C13.4789 8.12588 14.2649 8.52146 14.8717 9.1283C15.4785 9.73515 15.8741 10.5211 16 11.37Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M17.5 6.5H17.51" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <h2 className="f-title">Connect</h2>
            </div>
          </div>

          <p className="f-text">
            Follow us on social media for updates and special offers.
          </p>

          <div className="f-social-links">
            <a href="https://www.instagram.com/noshandnector?igsh=YTFkanVnYXBqYTdh" className="f-social-link" aria-label="Instagram">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z" stroke="currentColor" strokeWidth="2" />
                <path d="M17 3H7C4.79086 3 3 4.79086 3 7V17C3 19.2091 4.79086 21 7 21H17C19.2091 21 21 19.2091 21 17V7C21 4.79086 19.2091 3 17 3Z" stroke="currentColor" strokeWidth="2" />
                <path d="M17.5 7.5C17.7761 7.5 18 7.27614 18 7C18 6.72386 17.7761 6.5 17.5 6.5C17.2239 6.5 17 6.72386 17 7C17 7.27614 17.2239 7.5 17.5 7.5Z" fill="currentColor" stroke="currentColor" />
              </svg>
            </a>

            <a href="https://www.facebook.com/share/1FdxVBaEiF/" className="f-social-link" aria-label="Facebook">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>

            <a href="https://www.tiktok.com/@nosh.and.nector?_r=1&_t=ZS-93hRnpia5f5" className="f-social-link" aria-label="TikTok">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"
                  fill="currentColor"
                  stroke="currentColor"
                  strokeWidth="0.5"
                  strokeLinecap="round"
                  strokeLinejoin="round" />
              </svg>
            </a>
            <a href="https://youtube.com/@noshandnector-r5j?si=uJaJh5E3hVSRR8H6" className="f-social-link" aria-label="YouTube">
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M23.498 6.186a2.974 2.974 0 0 0-2.09-2.103C19.505 3.5 12 3.5 12 3.5s-7.505 0-9.408.583a2.974 2.974 0 0 0-2.09 2.103A31.27 31.27 0 0 0 .5 12c-.014 1.96.19 3.917.602 5.814a2.974 2.974 0 0 0 2.09 2.103C4.495 20.5 12 20.5 12 20.5s7.505 0 9.408-.583a2.974 2.974 0 0 0 2.09-2.103A31.27 31.27 0 0 0 23.5 12c.014-1.96-.19-3.917-.602-5.814zM9.75 15.02V8.98L15.5 12l-5.75 3.02z"
                  fill="currentColor"
                />
              </svg>
            </a>


            {/* <a href="#" className="f-social-link" aria-label="LinkedIn">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M16 8C17.5913 8 19.1174 8.63214 20.2426 9.75736C21.3679 10.8826 22 12.4087 22 14V21H18V14C18 13.4696 17.7893 12.9609 17.4142 12.5858C17.0391 12.2107 16.5304 12 16 12C15.4696 12 14.9609 12.2107 14.5858 12.5858C14.2107 12.9609 14 13.4696 14 14V21H10V14C10 12.4087 10.6321 10.8826 11.7574 9.75736C12.8826 8.63214 14.4087 8 16 8Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6 9H2V21H6V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M4 6C5.10457 6 6 5.10457 6 4C6 2.89543 5.10457 2 4 2C2.89543 2 2 2.89543 2 4C2 5.10457 2.89543 6 4 6Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a> */}
          </div>
        </div>

      </div>

      {/* Bottom Divider */}
      <div className="f-divider"></div>

      {/* Copyright */}
      <div className="f-copyright">
        <p>© 2025 Nosh & Nector. All rights reserved.</p>
        {/* <div className="f-legal-links">
          <a href="#">Privacy Policy</a>
          <span className="f-separator">•</span>
          <a href="#">Terms of Service</a>
          <span className="f-separator">•</span>
          <a href="#">Cookie Policy</a>
        </div> */}
      </div>

    </footer>
  );
}